<template>
    <div class="course-present" v-click-outside="close">
        <div class="course-present-row row" v-if="courses">
            <div class="col-12 course-present-header">
                <img src="@/assets/hometeacher/images/course-present-large.png">
                <span v-if="courses.length > 1">{{ $t('courses') }}</span><span v-else>{{ $t('courses') }}</span> {{ $t('as_gift') }}
                <span class="close-btn" @click.stop="close"><img src="@/assets/hometeacher/images/close.png"></span>
            </div>
            <div class="col-12" v-for="(course, index) in courses" :key="course.id">
                <CoursePresentListItem
                        :course="course"
                        :last-item="index === courses.length - 1"
                        @more="more"/>
            </div>
            <div class="col-12 course-present-description" v-if="courses.length === 1">
                {{ stripHtml(courses[0].description) }}
            </div>
        </div>
    </div>
</template>

<script>


    import CoursePresentListItem from "./CoursePresentListItem";

    export default {
        name: "CoursePresents",
        components: {CoursePresentListItem},
        props: {
            title: String,
            courses: {
                type: Array,
            },
        },

        data() {
            return {}
        },

        mounted() {

        },

        computed: {},

        watch: {},

        methods: {
            more(course) {
                this.$emit('more', course)
            },

            close() {
                this.$emit('close')
            },

            stripHtml(html) {
                // Create a new div element
                var temporalDivElement = document.createElement("div");
                // Set the HTML content with the providen
                temporalDivElement.innerHTML = html;
                // Retrieve the text property of the element (cross-browser support)
                return temporalDivElement.textContent || temporalDivElement.innerText || "";
            },
        },

    }
</script>

<style scoped>

    .course-present {
        text-align: left;
        position: relative;
    }

    .course-present-row {
        position: absolute;
        background: white;
        z-index: 2;
        width: 500px;
        border: 1px solid #d7e1e5;
        border-radius: 10px;
        box-shadow: 0px -1px 6px 2px #0000001a;
        right: 0;
        padding: 20px 10px;
    }

    .course-present-description {
        color: #4f4d5c;
        font-family: Manrope Light;
        font-size: 16px;
        margin-top: 20px;
    }

    .course-present-header {
        font-family: "Manrope Bold";
        font-size: 24px;
        margin-bottom: 30px;
        color: #ed1c24;
    }

    .course-present-header > img {
        margin-right: 8px;
        margin-bottom: 8px;
    }

    .close-btn {
        float: right;
        position: relative;
        top: -12px;
    }

    @media (max-width: 580px) {
        .course-present-row {
            max-width: 100%;
        }
    }
</style>

